import { Box, Typography } from '@mui/material'
import { type TransactionStatus } from '../../types/api'
import { getTransactionStatusType } from '../../utils/transactionStatusUtils'
import { useTranslation } from 'react-i18next'

export const TransactionStatusCheck = ({
  status,
}: {
  status: TransactionStatus
}) => {
  const { t } = useTranslation()
  const { label, color } = getTransactionStatusType(status, t)

  return (
    <Box
      sx={{
        paddingX: 0.5,
        border: `1px solid ${color}`,
      }}
    >
      <Typography variant='caption' sx={{ color }}>
        {label}
      </Typography>
    </Box>
  )
}
